<template>
  <div class="page-categories">
  <main>
      <section class="border-b border-gray-100 bg-gray-50">
        <div class="mx-auto max-w-[1400px] px-4 py-12 lg:px-8">
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p class="text-xs font-semibold uppercase text-muted">Categories</p>
              <h1 class="text-3xl font-semibold text-ink sm:text-4xl">Browse by category</h1>
              <p class="text-sm text-muted">Jump into vendors grouped by what you need most.</p>
            </div>
            <a class="text-sm font-semibold text-brand hover:text-brandDark" href="/vendors">View all vendors →</a>
          </div>
        </div>
      </section>

      <section class="mx-auto max-w-[1400px] px-4 py-10 lg:px-8">
        <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          <article class="rounded-3xl bg-white p-5 shadow-card ring-1 ring-gray-100">
            <img class="h-48 w-full rounded-2xl object-cover" src="https://dummyimage.com/640x420/e7f1ff/111827" alt="Venues">
            <div class="mt-4 flex items-center justify-between">
              <div>
                <p class="text-lg font-semibold text-ink">Venues</p>
                <p class="text-sm text-muted">Lofts, rooftops, vineyards, and coastal escapes.</p>
              </div>
              <a class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white transition hover:bg-brandDark" href="/vendors">Browse</a>
            </div>
          </article>
          <article class="rounded-3xl bg-white p-5 shadow-card ring-1 ring-gray-100">
            <img class="h-48 w-full rounded-2xl object-cover" src="https://dummyimage.com/640x420/fff1f5/111827" alt="Planners">
            <div class="mt-4 flex items-center justify-between">
              <div>
                <p class="text-lg font-semibold text-ink">Planners</p>
                <p class="text-sm text-muted">Day-of, partial, and full-service planning partners.</p>
              </div>
              <a class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white transition hover:bg-brandDark" href="/vendors">Browse</a>
            </div>
          </article>
          <article class="rounded-3xl bg-white p-5 shadow-card ring-1 ring-gray-100">
            <img class="h-48 w-full rounded-2xl object-cover" src="https://dummyimage.com/640x420/fffaf0/111827" alt="Photography">
            <div class="mt-4 flex items-center justify-between">
              <div>
                <p class="text-lg font-semibold text-ink">Photography</p>
                <p class="text-sm text-muted">Editorial, documentary, film, and candid storytellers.</p>
              </div>
              <a class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white transition hover:bg-brandDark" href="/vendors">Browse</a>
            </div>
          </article>
          <article class="rounded-3xl bg-white p-5 shadow-card ring-1 ring-gray-100">
            <img class="h-48 w-full rounded-2xl object-cover" src="https://dummyimage.com/640x420/f2f7ff/111827" alt="Decor">
            <div class="mt-4 flex items-center justify-between">
              <div>
                <p class="text-lg font-semibold text-ink">Decor & Florals</p>
                <p class="text-sm text-muted">Statement arches, floral clouds, lighting, and lounge sets.</p>
              </div>
              <a class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white transition hover:bg-brandDark" href="/vendors">Browse</a>
            </div>
          </article>
          <article class="rounded-3xl bg-white p-5 shadow-card ring-1 ring-gray-100">
            <img class="h-48 w-full rounded-2xl object-cover" src="https://dummyimage.com/640x420/fff6e8/111827" alt="Catering">
            <div class="mt-4 flex items-center justify-between">
              <div>
                <p class="text-lg font-semibold text-ink">Catering & Bar</p>
                <p class="text-sm text-muted">Chef-led menus, tastings, mixology, and cake artists.</p>
              </div>
              <a class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white transition hover:bg-brandDark" href="/vendors">Browse</a>
            </div>
          </article>
          <article class="rounded-3xl bg-white p-5 shadow-card ring-1 ring-gray-100">
            <img class="h-48 w-full rounded-2xl object-cover" src="https://dummyimage.com/640x420/e6f8ef/111827" alt="Music">
            <div class="mt-4 flex items-center justify-between">
              <div>
                <p class="text-lg font-semibold text-ink">Music & DJs</p>
                <p class="text-sm text-muted">Strings, bands, DJs, and custom playlists.</p>
              </div>
              <a class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white transition hover:bg-brandDark" href="/vendors">Browse</a>
            </div>
          </article>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'CategoriesView'
}
</script>
